import { useQuery } from '@tanstack/react-query';
import { fetchGeoCountry } from '@/api/geo';

export function useGeoCountry() {
  return useQuery<string | null>({
    queryKey: ['geo-country'],
    queryFn: ({ signal }) => fetchGeoCountry(signal),
    // 失敗してもロケールにフォールバックするだけなので、再試行で初期値の決定を遅らせない
    retry: false,
    staleTime: Infinity,
  });
}
